import { createSlice } from '@reduxjs/toolkit';
import { mapOrder } from '../../utilities/mapResponse';

const initialState = {
  orders: [],
  orderArray: []
};
const orderSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrders(state, action) {
      state.orders = mapOrder(action.payload);
    },
    setOrderArray(state, action) {
      state.orderArray = action.payload;
    },
    appendOrders: (state, action) => {
      const newOrders = mapOrder([action.payload]);
      state.orders = state.orders.concat(newOrders);
      state.orderArray = [...state.orderArray, ...[action.payload]];
    },
    updateOrder: (state, action) => {
      const { positionId, data } = action.payload;
      state.orders = state.orders.map(order => {
        if (order.positionId === positionId) {
          return { ...order, ...data };
        }
        return order;
      });
      state.orderArray = state.orderArray.map(order => 
        order.positionId === positionId ? { ...order, ...data } : order
      );
    },
    deleteOrders: (state, action) => {
      const orderIds = Array.isArray(action.payload) ? action.payload : [action.payload];
      state.orders = state.orders.filter(order =>
        order && !orderIds.includes(order.positionId)
      );
      state.orderArray = state.orderArray.filter(order =>
        order && !orderIds.includes(order.positionId)
      );
    }
  }
});

export const { setOrders, appendOrders, deleteOrders, updateOrder, setOrderArray } = orderSlice.actions;

const orderReducer = orderSlice.reducer;
export default orderReducer;
